/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as PublicRouteRouteImport } from './routes/_public/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminStudiosRouteImport } from './routes/admin/studios'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminModelsRouteImport } from './routes/admin/models'
import { Route as AdminEmailsRouteImport } from './routes/admin/emails'
import { Route as AdminContactsRouteImport } from './routes/admin/contacts'
import { Route as AdminApplicationsRouteImport } from './routes/admin/applications'
import { Route as PublicResidenceRouteImport } from './routes/_public/residence'
import { Route as PublicPolitiqueDeConfidentialiteRouteImport } from './routes/_public/politique-de-confidentialite'
import { Route as PublicMentionsLegalesRouteImport } from './routes/_public/mentions-legales'
import { Route as PublicContactRouteImport } from './routes/_public/contact'
import { Route as PublicCandidatureRouteRouteImport } from './routes/_public/candidature/route'
import { Route as PublicStudiosIndexRouteImport } from './routes/_public/studios/index'
import { Route as PublicCandidatureIndexRouteImport } from './routes/_public/candidature/index'
import { Route as ReservationStudioNumberRouteImport } from './routes/reservation/studio/$number'
import { Route as ReservationBookingNumberRouteImport } from './routes/reservation/booking/$number'
import { Route as PublicStudiosDisponiblesRouteImport } from './routes/_public/studios/disponibles'
import { Route as PublicStudiosNumberIndexRouteImport } from './routes/_public/studios/$number/index'
import { Route as PublicStudiosNumberCandidatureRouteImport } from './routes/_public/studios/$number/candidature'
import { Route as PublicCandidatureDocumentsTokenRouteImport } from './routes/_public/candidature/documents.$token'

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminStudiosRoute = AdminStudiosRouteImport.update({
  id: '/studios',
  path: '/studios',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminModelsRoute = AdminModelsRouteImport.update({
  id: '/models',
  path: '/models',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminEmailsRoute = AdminEmailsRouteImport.update({
  id: '/emails',
  path: '/emails',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminContactsRoute = AdminContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminApplicationsRoute = AdminApplicationsRouteImport.update({
  id: '/applications',
  path: '/applications',
  getParentRoute: () => AdminRouteRoute,
} as any)
const PublicResidenceRoute = PublicResidenceRouteImport.update({
  id: '/residence',
  path: '/residence',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicPolitiqueDeConfidentialiteRoute =
  PublicPolitiqueDeConfidentialiteRouteImport.update({
    id: '/politique-de-confidentialite',
    path: '/politique-de-confidentialite',
    getParentRoute: () => PublicRouteRoute,
  } as any)
const PublicMentionsLegalesRoute = PublicMentionsLegalesRouteImport.update({
  id: '/mentions-legales',
  path: '/mentions-legales',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicContactRoute = PublicContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicCandidatureRouteRoute = PublicCandidatureRouteRouteImport.update({
  id: '/candidature',
  path: '/candidature',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicStudiosIndexRoute = PublicStudiosIndexRouteImport.update({
  id: '/studios/',
  path: '/studios/',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicCandidatureIndexRoute = PublicCandidatureIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicCandidatureRouteRoute,
} as any)
const ReservationStudioNumberRoute = ReservationStudioNumberRouteImport.update({
  id: '/reservation/studio/$number',
  path: '/reservation/studio/$number',
  getParentRoute: () => rootRouteImport,
} as any)
const ReservationBookingNumberRoute =
  ReservationBookingNumberRouteImport.update({
    id: '/reservation/booking/$number',
    path: '/reservation/booking/$number',
    getParentRoute: () => rootRouteImport,
  } as any)
const PublicStudiosDisponiblesRoute =
  PublicStudiosDisponiblesRouteImport.update({
    id: '/studios/disponibles',
    path: '/studios/disponibles',
    getParentRoute: () => PublicRouteRoute,
  } as any)
const PublicStudiosNumberIndexRoute =
  PublicStudiosNumberIndexRouteImport.update({
    id: '/studios/$number/',
    path: '/studios/$number/',
    getParentRoute: () => PublicRouteRoute,
  } as any)
const PublicStudiosNumberCandidatureRoute =
  PublicStudiosNumberCandidatureRouteImport.update({
    id: '/studios/$number/candidature',
    path: '/studios/$number/candidature',
    getParentRoute: () => PublicRouteRoute,
  } as any)
const PublicCandidatureDocumentsTokenRoute =
  PublicCandidatureDocumentsTokenRouteImport.update({
    id: '/documents/$token',
    path: '/documents/$token',
    getParentRoute: () => PublicCandidatureRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/candidature': typeof PublicCandidatureRouteRouteWithChildren
  '/contact': typeof PublicContactRoute
  '/mentions-legales': typeof PublicMentionsLegalesRoute
  '/politique-de-confidentialite': typeof PublicPolitiqueDeConfidentialiteRoute
  '/residence': typeof PublicResidenceRoute
  '/admin/applications': typeof AdminApplicationsRoute
  '/admin/contacts': typeof AdminContactsRoute
  '/admin/emails': typeof AdminEmailsRoute
  '/admin/models': typeof AdminModelsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/studios': typeof AdminStudiosRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/': typeof AdminIndexRoute
  '/studios/disponibles': typeof PublicStudiosDisponiblesRoute
  '/reservation/booking/$number': typeof ReservationBookingNumberRoute
  '/reservation/studio/$number': typeof ReservationStudioNumberRoute
  '/candidature/': typeof PublicCandidatureIndexRoute
  '/studios/': typeof PublicStudiosIndexRoute
  '/candidature/documents/$token': typeof PublicCandidatureDocumentsTokenRoute
  '/studios/$number/candidature': typeof PublicStudiosNumberCandidatureRoute
  '/studios/$number/': typeof PublicStudiosNumberIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/contact': typeof PublicContactRoute
  '/mentions-legales': typeof PublicMentionsLegalesRoute
  '/politique-de-confidentialite': typeof PublicPolitiqueDeConfidentialiteRoute
  '/residence': typeof PublicResidenceRoute
  '/admin/applications': typeof AdminApplicationsRoute
  '/admin/contacts': typeof AdminContactsRoute
  '/admin/emails': typeof AdminEmailsRoute
  '/admin/models': typeof AdminModelsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/studios': typeof AdminStudiosRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin': typeof AdminIndexRoute
  '/studios/disponibles': typeof PublicStudiosDisponiblesRoute
  '/reservation/booking/$number': typeof ReservationBookingNumberRoute
  '/reservation/studio/$number': typeof ReservationStudioNumberRoute
  '/candidature': typeof PublicCandidatureIndexRoute
  '/studios': typeof PublicStudiosIndexRoute
  '/candidature/documents/$token': typeof PublicCandidatureDocumentsTokenRoute
  '/studios/$number/candidature': typeof PublicStudiosNumberCandidatureRoute
  '/studios/$number': typeof PublicStudiosNumberIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_public': typeof PublicRouteRouteWithChildren
  '/admin': typeof AdminRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/_public/candidature': typeof PublicCandidatureRouteRouteWithChildren
  '/_public/contact': typeof PublicContactRoute
  '/_public/mentions-legales': typeof PublicMentionsLegalesRoute
  '/_public/politique-de-confidentialite': typeof PublicPolitiqueDeConfidentialiteRoute
  '/_public/residence': typeof PublicResidenceRoute
  '/admin/applications': typeof AdminApplicationsRoute
  '/admin/contacts': typeof AdminContactsRoute
  '/admin/emails': typeof AdminEmailsRoute
  '/admin/models': typeof AdminModelsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/studios': typeof AdminStudiosRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/': typeof AdminIndexRoute
  '/_public/studios/disponibles': typeof PublicStudiosDisponiblesRoute
  '/reservation/booking/$number': typeof ReservationBookingNumberRoute
  '/reservation/studio/$number': typeof ReservationStudioNumberRoute
  '/_public/candidature/': typeof PublicCandidatureIndexRoute
  '/_public/studios/': typeof PublicStudiosIndexRoute
  '/_public/candidature/documents/$token': typeof PublicCandidatureDocumentsTokenRoute
  '/_public/studios/$number/candidature': typeof PublicStudiosNumberCandidatureRoute
  '/_public/studios/$number/': typeof PublicStudiosNumberIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/login'
    | '/unauthorized'
    | '/candidature'
    | '/contact'
    | '/mentions-legales'
    | '/politique-de-confidentialite'
    | '/residence'
    | '/admin/applications'
    | '/admin/contacts'
    | '/admin/emails'
    | '/admin/models'
    | '/admin/settings'
    | '/admin/studios'
    | '/admin/users'
    | '/admin/'
    | '/studios/disponibles'
    | '/reservation/booking/$number'
    | '/reservation/studio/$number'
    | '/candidature/'
    | '/studios/'
    | '/candidature/documents/$token'
    | '/studios/$number/candidature'
    | '/studios/$number/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/unauthorized'
    | '/contact'
    | '/mentions-legales'
    | '/politique-de-confidentialite'
    | '/residence'
    | '/admin/applications'
    | '/admin/contacts'
    | '/admin/emails'
    | '/admin/models'
    | '/admin/settings'
    | '/admin/studios'
    | '/admin/users'
    | '/admin'
    | '/studios/disponibles'
    | '/reservation/booking/$number'
    | '/reservation/studio/$number'
    | '/candidature'
    | '/studios'
    | '/candidature/documents/$token'
    | '/studios/$number/candidature'
    | '/studios/$number'
  id:
    | '__root__'
    | '/'
    | '/_public'
    | '/admin'
    | '/login'
    | '/unauthorized'
    | '/_public/candidature'
    | '/_public/contact'
    | '/_public/mentions-legales'
    | '/_public/politique-de-confidentialite'
    | '/_public/residence'
    | '/admin/applications'
    | '/admin/contacts'
    | '/admin/emails'
    | '/admin/models'
    | '/admin/settings'
    | '/admin/studios'
    | '/admin/users'
    | '/admin/'
    | '/_public/studios/disponibles'
    | '/reservation/booking/$number'
    | '/reservation/studio/$number'
    | '/_public/candidature/'
    | '/_public/studios/'
    | '/_public/candidature/documents/$token'
    | '/_public/studios/$number/candidature'
    | '/_public/studios/$number/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
  ReservationBookingNumberRoute: typeof ReservationBookingNumberRoute
  ReservationStudioNumberRoute: typeof ReservationStudioNumberRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/studios': {
      id: '/admin/studios'
      path: '/studios'
      fullPath: '/admin/studios'
      preLoaderRoute: typeof AdminStudiosRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/models': {
      id: '/admin/models'
      path: '/models'
      fullPath: '/admin/models'
      preLoaderRoute: typeof AdminModelsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/emails': {
      id: '/admin/emails'
      path: '/emails'
      fullPath: '/admin/emails'
      preLoaderRoute: typeof AdminEmailsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/contacts': {
      id: '/admin/contacts'
      path: '/contacts'
      fullPath: '/admin/contacts'
      preLoaderRoute: typeof AdminContactsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/applications': {
      id: '/admin/applications'
      path: '/applications'
      fullPath: '/admin/applications'
      preLoaderRoute: typeof AdminApplicationsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/_public/residence': {
      id: '/_public/residence'
      path: '/residence'
      fullPath: '/residence'
      preLoaderRoute: typeof PublicResidenceRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/politique-de-confidentialite': {
      id: '/_public/politique-de-confidentialite'
      path: '/politique-de-confidentialite'
      fullPath: '/politique-de-confidentialite'
      preLoaderRoute: typeof PublicPolitiqueDeConfidentialiteRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/mentions-legales': {
      id: '/_public/mentions-legales'
      path: '/mentions-legales'
      fullPath: '/mentions-legales'
      preLoaderRoute: typeof PublicMentionsLegalesRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/contact': {
      id: '/_public/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof PublicContactRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/candidature': {
      id: '/_public/candidature'
      path: '/candidature'
      fullPath: '/candidature'
      preLoaderRoute: typeof PublicCandidatureRouteRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/studios/': {
      id: '/_public/studios/'
      path: '/studios'
      fullPath: '/studios/'
      preLoaderRoute: typeof PublicStudiosIndexRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/candidature/': {
      id: '/_public/candidature/'
      path: '/'
      fullPath: '/candidature/'
      preLoaderRoute: typeof PublicCandidatureIndexRouteImport
      parentRoute: typeof PublicCandidatureRouteRoute
    }
    '/reservation/studio/$number': {
      id: '/reservation/studio/$number'
      path: '/reservation/studio/$number'
      fullPath: '/reservation/studio/$number'
      preLoaderRoute: typeof ReservationStudioNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reservation/booking/$number': {
      id: '/reservation/booking/$number'
      path: '/reservation/booking/$number'
      fullPath: '/reservation/booking/$number'
      preLoaderRoute: typeof ReservationBookingNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/studios/disponibles': {
      id: '/_public/studios/disponibles'
      path: '/studios/disponibles'
      fullPath: '/studios/disponibles'
      preLoaderRoute: typeof PublicStudiosDisponiblesRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/studios/$number/': {
      id: '/_public/studios/$number/'
      path: '/studios/$number'
      fullPath: '/studios/$number/'
      preLoaderRoute: typeof PublicStudiosNumberIndexRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/studios/$number/candidature': {
      id: '/_public/studios/$number/candidature'
      path: '/studios/$number/candidature'
      fullPath: '/studios/$number/candidature'
      preLoaderRoute: typeof PublicStudiosNumberCandidatureRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/candidature/documents/$token': {
      id: '/_public/candidature/documents/$token'
      path: '/documents/$token'
      fullPath: '/candidature/documents/$token'
      preLoaderRoute: typeof PublicCandidatureDocumentsTokenRouteImport
      parentRoute: typeof PublicCandidatureRouteRoute
    }
  }
}

interface PublicCandidatureRouteRouteChildren {
  PublicCandidatureIndexRoute: typeof PublicCandidatureIndexRoute
  PublicCandidatureDocumentsTokenRoute: typeof PublicCandidatureDocumentsTokenRoute
}

const PublicCandidatureRouteRouteChildren: PublicCandidatureRouteRouteChildren =
  {
    PublicCandidatureIndexRoute: PublicCandidatureIndexRoute,
    PublicCandidatureDocumentsTokenRoute: PublicCandidatureDocumentsTokenRoute,
  }

const PublicCandidatureRouteRouteWithChildren =
  PublicCandidatureRouteRoute._addFileChildren(
    PublicCandidatureRouteRouteChildren,
  )

interface PublicRouteRouteChildren {
  PublicCandidatureRouteRoute: typeof PublicCandidatureRouteRouteWithChildren
  PublicContactRoute: typeof PublicContactRoute
  PublicMentionsLegalesRoute: typeof PublicMentionsLegalesRoute
  PublicPolitiqueDeConfidentialiteRoute: typeof PublicPolitiqueDeConfidentialiteRoute
  PublicResidenceRoute: typeof PublicResidenceRoute
  PublicStudiosDisponiblesRoute: typeof PublicStudiosDisponiblesRoute
  PublicStudiosIndexRoute: typeof PublicStudiosIndexRoute
  PublicStudiosNumberCandidatureRoute: typeof PublicStudiosNumberCandidatureRoute
  PublicStudiosNumberIndexRoute: typeof PublicStudiosNumberIndexRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicCandidatureRouteRoute: PublicCandidatureRouteRouteWithChildren,
  PublicContactRoute: PublicContactRoute,
  PublicMentionsLegalesRoute: PublicMentionsLegalesRoute,
  PublicPolitiqueDeConfidentialiteRoute: PublicPolitiqueDeConfidentialiteRoute,
  PublicResidenceRoute: PublicResidenceRoute,
  PublicStudiosDisponiblesRoute: PublicStudiosDisponiblesRoute,
  PublicStudiosIndexRoute: PublicStudiosIndexRoute,
  PublicStudiosNumberCandidatureRoute: PublicStudiosNumberCandidatureRoute,
  PublicStudiosNumberIndexRoute: PublicStudiosNumberIndexRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

interface AdminRouteRouteChildren {
  AdminApplicationsRoute: typeof AdminApplicationsRoute
  AdminContactsRoute: typeof AdminContactsRoute
  AdminEmailsRoute: typeof AdminEmailsRoute
  AdminModelsRoute: typeof AdminModelsRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminStudiosRoute: typeof AdminStudiosRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminApplicationsRoute: AdminApplicationsRoute,
  AdminContactsRoute: AdminContactsRoute,
  AdminEmailsRoute: AdminEmailsRoute,
  AdminModelsRoute: AdminModelsRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminStudiosRoute: AdminStudiosRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PublicRouteRoute: PublicRouteRouteWithChildren,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  UnauthorizedRoute: UnauthorizedRoute,
  ReservationBookingNumberRoute: ReservationBookingNumberRoute,
  ReservationStudioNumberRoute: ReservationStudioNumberRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
